import { Fragment } from 'react';

const ImagePicker = Fragment;
export default ImagePicker;
